import * as React from 'react'
import { ReactNode } from 'react'
type Props = {
  className?: string
  children?: ReactNode
}

export const SidebarMenu = ({ className, children }: Props) => {
  return (
    <nav className={className}>
      <ul className="tw-flex tw-flex-1 tw-grow tw-flex-col tw-items-stretch tw-gap-1 tw-px-1.5 tw-py-3">
        {React.Children.toArray(children).map((c, i) => (
          <li key={i}>{c}</li>
        ))}
      </ul>
    </nav>
  )
}
